var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.isOffice)?_c('CompanyDeposit'):_vm._e(),(_vm.isSupperDealer)?_c('SupperDealerDeposit'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }